import { ListUser } from "models/list-user";
import { doDelete, doGet, doPatch, doPost, parseListPath } from "../request";
import { Locale, LocaleString } from "models/locale";
import { List } from "models/list";

export const adminDoGetListUsers = async (list: List) => {
  const users = await doGet<ListUser[]>(parseListPath(list, "users"));
  return users;
};

export const adminDoGetArchivedListUsers = async (list: List) => {
  const users = await doGet<ListUser[]>(parseListPath(list, "users/archived"));
  return users;
};

export const adminDoGetListUser = async (list: List, userUuid: string) => {
  const user = await doGet<ListUser>(parseListPath(list, `user/${userUuid}`));
  return user;
};

export const adminDoDeleteListUser = async (list: List, userUuid: string) => {
  await doDelete(parseListPath(list, `user/${userUuid}`));
};

export const adminDoPostListUser = async (
  list: List,
  email: string,
  locale: Locale,
) => {
  const user = await doPost<ListUser>(parseListPath(list, `user`), {
    email,
    locale,
  });
  return user;
};

export const adminDoPatchListUser = async (
  list: List,
  listUserUuid: string,
  data: Partial<ListUser & { send_email: boolean }>,
) => {
  const user = await doPatch<ListUser>(
    parseListPath(list, `user/${listUserUuid}`),
    data,
  );
  return user;
};

export const adminDoPatchListUserStatusReject = async (
  list: List,
  listUserUuid: string,
  send_email: boolean,
  subject: string,
  message: string,
) => {
  const user = await doPost<ListUser>(
    parseListPath(list, `user/${listUserUuid}/status/reject`),
    { send_email, subject, message },
  );
  return user;
};

export const adminDoPatchListUserStatusSubmit = async (
  list: List,
  listUserUuid: string,
) => {
  const user = await doPost<ListUser>(
    parseListPath(list, `user/${listUserUuid}/status/submit`),
    {},
  );
  return user;
};

export const adminDoPatchListUserStatusApprove = async (
  list: List,
  listUserUuid: string,
  approved_at: string,
  send_email: boolean,
  subject: LocaleString,
  message: LocaleString,
) => {
  const user = await doPost<ListUser>(
    parseListPath(list, `user/${listUserUuid}/status/approve`),
    { send_email, approved_at, subject, message },
  );
  return user;
};

export const adminDoPostListUserGenerate = async (
  list: List,
  listUserUuid: string,
) => {
  const user = await doPost<ListUser>(
    parseListPath(list, `user/${listUserUuid}/generate`),
    {},
  );
  return user;
};
